import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Council } from 'types';
import { State } from 'redux/initialState';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { boardEntityTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardEntityTypes';
import { boardsViewTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardsViewTypes';

import { BoardEntityTypes } from 'types/Board';
import BoardsListHeader from 'modules/_shared/components/BoardsListHeader';
import { useGetCouncilsList } from './hooks/useGetCouncilsList';
import CouncilsListBody from './components/CouncilsListBody';
import CouncilsListBanner from './components/CouncilsListBanner';
import CouncilsSummarySection from './components/CouncilsSummarySection';
import CouncilsRecentsSection from './components/CouncilsRecentsSection';

export type CouncilsView = 'LIST' | 'DASHBOARD';

export enum CouncilsViews {
  LIST = 'LIST',
  DASHBOARD = 'DASHBOARD',
}

const CouncilsList: FC = () => {
  const { societyId, memberId } = useParams();

  const councils: Council[] = useSelector((state: State) => state.councils);
  const { isAdmin, isDirector } = useSelector(
    (state: State) => state.society?.role || {}
  );
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const [councilsView, setCouncilsView] = useState<string>(
    boardsViewTypes.DASHBOARD
  );

  const { isLoading, isError } = useGetCouncilsList(societyId);

  useGetMenu();
  useGetActualSociety(societyId);

  const handleChangeView = () => {
    setCouncilsView(
      councilsView === boardsViewTypes.LIST
        ? boardsViewTypes.DASHBOARD
        : boardsViewTypes.LIST
    );
  };

  return (
    <Page id="councils-list-page">
      <BoardsListHeader
        boardType={boardEntityTypes.COUNCIL as BoardEntityTypes}
        viewType={councilsView}
        boardsCount={councils?.length || 0}
        onChangeView={handleChangeView}
      />

      {councilsView === boardsViewTypes.DASHBOARD ? (
        <>
          <CouncilsSummarySection councils={councils} />
          {/* {isAdmin && <CouncilsCtaSection />} */}
          <CouncilsRecentsSection councils={councils} />
        </>
      ) : (
        <>
          {isAdmin && (
            <CouncilsListBody councils={councils} society={actualSociety} />
          )}
        </>
      )}

      <CouncilsListBanner />

      {isLoading && <CustomLoading />}
    </Page>
  );
};

export default CouncilsList;
